import QueryString from 'qs'
import { apiClient } from '../client'
import { NoteForm, NoteListQueryParams, NoteListRequest } from './types'

export const getNotesById = async (request: NoteListRequest) => {
    const { params, queryParams } = request
    const { noteEntity, id } = params

    const url = `v1/${noteEntity}-note/parent/${id}`

    const response = await apiClient(url, {
        params: queryParams,
        paramsSerializer: (queryParams: NoteListQueryParams) => {
            return QueryString.stringify(queryParams)
        },
    })

    return response.data
}

export const createUpdateNote = async (data: NoteForm, isEdit?: boolean) => {
    const url = isEdit ? `v1/${data.noteEntity}-note/${data.id}` : `v1/${data.noteEntity}-note`

    const response = await apiClient(url, {
        method: isEdit ? 'PUT' : 'POST',
        data: data,
    })

    return response.data
}

export const deleteNoteById = async (noteId: number | string, noteEntity: string) => {
    const response = await apiClient(`v1/${noteEntity}-note/${noteId}`, {
        method: 'DELETE',
    })

    return response.data
}
